import React, {Component} from 'react';
import {SaveBar} from "../../elements/SaveBar";
import {APIClient} from "../../../utils/APIClient";
import {typedErrorMessage} from "../../../utils/typedErrorMessage";
import {BusinessUnitMainInfo} from "./BusinessUnitMainInfo";
import {BU_PERIOD_TEMPORARY} from "../../../periods";
import {ItemScheduleConfiguration} from "../../../utils/ItemScheduleConfiguration";
import { withTranslation } from 'react-i18next';
import {toast} from 'react-toastify';
import {BudgetHelper, PARTIAL_GOALS_INPUT_MODE_CUMULATIVE, PARTIAL_GOALS_INPUT_MODE_DAILY_RANGE} from "../../../utils/BudgetHelper";
import {lineSavedMessage} from "../../../utils/lineRecalculation";

class BusinessUnitGlobalInfoFormClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasChanges: false,
            saving: false,
            name: this.props.name,
            allocatedBudget: this.props.allocatedBudget,
            budgetCurrency: this.props.budgetCurrency,
            leftoverBudget: this.props.leftoverBudget,
            rollover: this.props.rollover,
            goal1: this.props.goal1,
            goal2: this.props.goal2,
            periodFirstDate: this.props.periodFirstDate,
            periodLastDate: this.props.periodLastDate,
            budgetPartialGoals: this.getBudgetPartialGoalsWithDates(this.props.budgetPartialGoals),
            partialGoalsInputMode: BudgetHelper.deriveInputModeFromDefinition(this.props.budgetPartialGoalsInputDefinition),
            partialGoalsInputDefinition: this.props.budgetPartialGoalsInputDefinition || null,
            itemScheduleConfiguration: this.props.itemScheduleConfiguration
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleRolloverChange = this.handleRolloverChange.bind(this);
        this.handleAllocatedBudgetChange = this.handleAllocatedBudgetChange.bind(this);
        this.handleBudgetCurrencyChange = this.handleBudgetCurrencyChange.bind(this);
        this.handleGoalCPAChange = this.handleGoalCPAChange.bind(this);
        this.handleGoalChange = this.handleGoalChange.bind(this);
        this.handlePeriodDatesChange = this.handlePeriodDatesChange.bind(this);
        this.handleScheduleConfiguration = this.handleScheduleConfiguration.bind(this);
    }

    getBudgetPartialGoalsWithDates(budgetPartialGoals) {
        const dic = [];

        if(budgetPartialGoals === undefined || budgetPartialGoals === null)
            return [];

        budgetPartialGoals.forEach(bpd => {
            dic.push({
                'date': bpd.date ? this.formatYYYYMMDDToDate(bpd.date) : null,
                'value': bpd.value,
                'type': bpd.type
            });
        })
        return dic;
    }

    formatYYYYMMDDToDate(yyyymmdd) {
        const year = parseInt(yyyymmdd.slice(0, 4), 10);
        const month = parseInt(yyyymmdd.slice(4, 6), 10) - 1; // Months are 0-indexed in JavaScript
        const day = parseInt(yyyymmdd.slice(6, 8), 10);

        return new Date(year, month, day);
    }

    // rendering

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <BusinessUnitMainInfo
                    itemScheduleConfiguration={new ItemScheduleConfiguration(this.state.itemScheduleConfiguration.data())}
                    onNameChange={this.handleNameChange}
                    periodType={this.props.periodType}
                    budgetType={this.props.budgetType}
                    periodFirstDate={this.state.periodFirstDate}
                    periodLastDate={this.state.periodLastDate}
                    firstDay={this.props.firstDay}
                    name={this.state.name}
                    totalBudget={this.props.totalBudget}
                    rollover={this.state.rollover}
                    canEditCurrency={this.props.canEditCurrency}
                    allocatedBudget={this.state.allocatedBudget}
                    budgetCurrency={this.state.budgetCurrency}
                    originalBudgetCurrency={this.props.budgetCurrency}
                    budgetPartialGoals={this.state.budgetPartialGoals}
                    budgetPartialGoalsInputDefinition={this.state.partialGoalsInputDefinition}
                    leftoverBudget={this.state.leftoverBudget}
                    goalCPA={this.state.goalCPA}
                    goal1={this.state.goal1}
                    goal2={this.state.goal2}
                    onRolloverChange={this.handleRolloverChange}
                    accountsQuantity={this.props.accountsQuantity}
                    linkedAccountCurrencies={this.props.linkedAccountCurrencies}
                    onBudgetChange={this.handleAllocatedBudgetChange}
                    onGoalCPAChange={this.handleGoalCPAChange}
                    onGoalChange={this.handleGoalChange}
                    onPeriodDatesChange={this.handlePeriodDatesChange}
                    onScheduleConfigurationChange={this.handleScheduleConfiguration}
                    adAccountsActionData={this.props.adAccountsActionData}
                />
                <SaveBar onClick={(e) => {
                    e.preventDefault();
                    const form = e.target.closest('form'); // Get the closest form element
                    if (form) form.dispatchEvent(new Event('submit', { bubbles: true })); // Trigger native form submit
                }} isSaving={this.state.saving}
                         hasChanges={this.state.hasChanges}/>
            </form>
        )
    }

    // handlers

    handleSubmit() {
        const data = this.postData();
        this.setState({saving: true});
        this.postForm(data).then((response) => {
            if (response.status === 'ERROR') {
                alert(response.error_message);
            } else if (typedErrorMessage(response)) {
                // Un error tipado llega con su código en `status`, así que no entra en ninguna
                // de las dos ramas de siempre y el guardado se quedaba MUDO: el botón volvía a
                // su estado y no pasaba nada. Sólo se atienden los códigos que sabemos explicar
                // (el helper devuelve null para el resto), para no mandar a la pantalla de error
                // un 200 de un endpoint que no manda `status`.
                alert(typedErrorMessage(response));
            } else if (response.status === 'OK') {
                this.setState({hasChanges: false});
                // Antes guardar no decía nada (card Fnvibexi).
                toast.success(lineSavedMessage(response, this.props.t, this.props.t('line_recalculation.saved')));
                this.props.afterGlobalInfoEdited({
                    budgetCurrency: this.state.budgetCurrency,
                    allocatedBudget: this.state.allocatedBudget,
                    leftoverBudget: this.state.leftoverBudget,
                    goalCPA: this.state.goalCPA,
                    goal1: this.state.goal1,
                    goal2: this.state.goal2
                })
            }
            this.setState({saving: false});
        });
    }

    postForm(data) {
        const apiClient = new APIClient(this.props.submitUrl);

        return apiClient.call('PUT', data);
    }

    postData() {
        const postData= {
            name: this.state.name,
            rollover: this.state.rollover,
            budget_currency: this.state.budgetCurrency,
            budget_amount: this.state.allocatedBudget,
            goal_cpa: this.state.goalCPA,
            goal_1: this.prepareGoalDataForPostData(this.state.goal1),
            goal_2: this.prepareGoalDataForPostData(this.state.goal2),
            schedule_configuration: this.state.itemScheduleConfiguration.data()
        }

        if (this.state.partialGoalsInputMode === PARTIAL_GOALS_INPUT_MODE_DAILY_RANGE) {
            const entries = (this.state.partialGoalsInputDefinition && this.state.partialGoalsInputDefinition.entries) || [];
            postData.budget_partial_goals = BudgetHelper.deriveCumulativeFromDailyRange(
                this.state.allocatedBudget, this.state.periodFirstDate, this.state.periodLastDate, entries,
            );
            postData.budget_partial_goals_input_definition = BudgetHelper.BudgetPartialGoalDailyRangeTranslateToSubmit(entries);
        } else {
            postData.budget_partial_goals = this.getBudgetPartialGoalsWithYYYYMMDDDates(this.state.budgetPartialGoals);
            postData.budget_partial_goals_input_definition = null;
        }

        if(this.shouldPostPeriodDates()) {
            postData["period_from_date"] = this.state.periodFirstDate;
            postData["period_to_date"] = this.state.periodLastDate;
        }

        return postData;
    }

    getBudgetPartialGoalsWithYYYYMMDDDates(budgetPartialGoals) {
        const dic = [];
        budgetPartialGoals.forEach(bpd => {
            dic.push({
                'date': bpd.date ? this.formatDateToYYYYMMDD(bpd.date) : null,
                'value': bpd.value,
                'type': bpd.type
            });
        })
        return dic;
    }

    formatDateToYYYYMMDD(date) {
        const day = String(date.getDate()).padStart(2, '0');    // Get day and pad with zero if needed
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Get month (0-based) and pad with zero
        const year = date.getFullYear();                        // Get full year

        return `${year}${month}${day}`;
    }

    periodTypeIsTemporal() {
        return this.props.periodType === BU_PERIOD_TEMPORARY;
    }

    shouldPostPeriodDates() {
        return this.periodTypeIsTemporal() && this.state.periodFirstDate && this.state.periodLastDate;
    }

    prepareGoalDataForPostData(goalData) {
        if(goalData === null) {
            return null;
        }

        return {
            "metric_name": goalData["metricName"],
            "value": goalData["value"],
            "metric_conversion_configuration": goalData["metricConversionConfiguration"] !== undefined ? goalData["metricConversionConfiguration"] : null
        };

    }

    handleScheduleConfiguration(itemScheduleConfiguration) {
        if(itemScheduleConfiguration.isSame(this.state.itemScheduleConfiguration))
            return;

        this.setState({
            ...this.state,
            itemScheduleConfiguration: itemScheduleConfiguration,
            hasChanges: true
        }, this.onChange);
    }

    handleNameChange(event) {
        const target = event.target;
        const name = target.name;

        this.setState({
            hasChanges: true,
            [name]: target.value
        }, this.onChange);
    }

    handleRolloverChange(value) {
        this.setState({
            hasChanges: true,
            rollover: value
        });

        this.onChange();
    }

    onChange() {
        this.props.onChange();
    }

    handleAllocatedBudgetChange(newCurrency, newAmount, newBudgetPartialGoals, partialGoalsConfig) {
        const update = {
            hasChanges: true,
            budgetCurrency: newCurrency,
            allocatedBudget: newAmount,
            budgetPartialGoals: newBudgetPartialGoals
        };
        if (partialGoalsConfig) {
            update.partialGoalsInputMode = partialGoalsConfig.inputMode || PARTIAL_GOALS_INPUT_MODE_CUMULATIVE;
            update.partialGoalsInputDefinition = partialGoalsConfig.inputDefinition || null;
        }
        this.setState(update);

        this.onChange();
    }

    handleBudgetCurrencyChange(value) {
        this.setState({
            hasChanges: true,
            budgetCurrency: value
        });

        this.onChange();
    }

    handleGoalCPAChange(value) {
        this.setState({
            hasChanges: true,
            goalCPA: value
        });

        this.onChange();
    }

    handleGoalChange(priority, data) {
        if (priority !== 1 && priority !== 2) {
            throw new Error('Goal priority not valid');
        }

        if (priority === 1)
        {
            this.setState({
                goal1: data,
                hasChanges: true
            });
        }

        if (priority === 2)
        {
            this.setState({
                goal2: data,
                hasChanges: true
            });
        }
    }

    handlePeriodDatesChange(periodFirstDate, periodLastDate) {
        if (!periodFirstDate || !periodLastDate) {
            throw new Error('Dates not valid');
        }

        this.setState({
            periodFirstDate: periodFirstDate.format("YYYY-MM-DD"),
            periodLastDate: periodLastDate.format("YYYY-MM-DD"),
            hasChanges: true
        });
    }

    // set state helpers
}

export const BusinessUnitGlobalInfoForm = withTranslation()(BusinessUnitGlobalInfoFormClass);
export default BusinessUnitGlobalInfoForm;
